import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './Blog.css'

import Separator from '../../Components/Separator/Separator'
import Note from '../../Components/Note/Note'
import Guide from '../../Components/Guide/Guide'
import Report from '../../Components/Report/Report'
import Presentation from '../../Components/Presentation/Presentation'
import Tale from '../../Components/Tale/Tale'
import SEO from '../../Components/SEO/SEO';
import PageTitle from '../../Hooks/PageTitle';

import ddpm from '../../Media/Blog.Media/Notes.Media/ddpm.png'
import vla from '../../Media/Blog.Media/Notes.Media/vla.png'

import drivescope_rep from '../../Media/Blog.Media/Reports.Media/drivescope.jpg'
import synesthesia_rep from '../../Media/Blog.Media/Reports.Media/synesthesia.jpg'
import echomind_rep from '../../Media/Blog.Media/Reports.Media/echomind.jpg'
import mindscan_rep from '../../Media/Blog.Media/Reports.Media/mindscan.jpg'
import bugscope_rep from '../../Media/Blog.Media/Reports.Media/bugscope.jpg'
import cyberquiz_rep from '../../Media/Blog.Media/Reports.Media/cyberquiz.jpg'
import cortext_rep from '../../Media/Blog.Media/Reports.Media/cortext.jpg'
import moroccoinsights_rep from '../../Media/Blog.Media/Reports.Media/moroccoinsights.jpg'
import neurodrive_rep from '../../Media/Blog.Media/Reports.Media/neurodrive.jpg'
import therabot_rep from '../../Media/Blog.Media/Reports.Media/therabot.jpg'
import logspectrum_rep from '../../Media/Blog.Media/Reports.Media/logspectrum.jpg'
import cabinetpro_rep from '../../Media/Blog.Media/Reports.Media/cabinetpro.jpg'

import drivescope_pre from '../../Media/Blog.Media/Presentations.Media/drivescope.jpg'
import synesthesia_pre from '../../Media/Blog.Media/Presentations.Media/synesthesia.jpg'
import graphsage_pre from '../../Media/Blog.Media/Presentations.Media/graphsage.jpg'
import wavegan_pre from '../../Media/Blog.Media/Presentations.Media/wavegan.jpg'
import cyberquiz_pre from '../../Media/Blog.Media/Presentations.Media/cyberquiz.jpg'
import genx_pre from '../../Media/Blog.Media/Presentations.Media/genx.jpg'
import dermalyze_pre from '../../Media/Blog.Media/Presentations.Media/dermalyze.jpg'
import cortext_pre from '../../Media/Blog.Media/Presentations.Media/cortext.jpg'
import clinicalner_pre from '../../Media/Blog.Media/Presentations.Media/clinicalner.jpg'
import db4o_pre from '../../Media/Blog.Media/Presentations.Media/db4o.jpg'

// import navigation_system from '../../Media/Blog.Media/Posters.Media/navigation_system.jpg'
import pulsex_pos from '../../Media/Blog.Media/Posters.Media/pulsex.jpg'
import neurodrive_pos from '../../Media/Blog.Media/Posters.Media/neurodrive.jpg'

// import neural_network from '../../Media/Blog.Media/Guides.Media/neural_network.jpg'
import raspberry from '../../Media/Blog.Media/Guides.Media/raspberry.jpg'
import arduino from '../../Media/Blog.Media/Guides.Media/arduino.jpg'
import git from '../../Media/Blog.Media/Guides.Media/git.jpg'

import embedded_system from '../../Media/Blog.Media/Tales.Media/embedded_system.jpg'

import read_paper from '../../Media/Blog.Media/Randoms.Media/read_paper.jpg'
import phd_thesis from '../../Media/Blog.Media/Randoms.Media/phd_thesis.jpg'
import mach_alg_exp from '../../Media/Blog.Media/Randoms.Media/mach_alg_exp.jpg'
import should_use from '../../Media/Blog.Media/Randoms.Media/should_use.jpg'
import tpu_gpu_npu_lpu from '../../Media/Blog.Media/Randoms.Media/tpu_gpu_npu_lpu.jpg'
import ai_terms from '../../Media/Blog.Media/Randoms.Media/ai_terms.jpg'
import master_tree from '../../Media/Blog.Media/Randoms.Media/master_tree.gif'
import prob_dist from '../../Media/Blog.Media/Randoms.Media/prob_dist.jpg'
import yolo_family from '../../Media/Blog.Media/Randoms.Media/yolo_family.jpg'
import finetunning from '../../Media/Blog.Media/Randoms.Media/finetunning.jpg'
import beginning from '../../Media/Blog.Media/Randoms.Media/beginning.jpg'
import ai_videos from '../../Media/Blog.Media/Randoms.Media/ai_videos.jpg'
import claude_md from '../../Media/Blog.Media/Randoms.Media/claude_md.jpg'
import which_tool from '../../Media/Blog.Media/Randoms.Media/which_tool.jpg'
import all_vs_all from '../../Media/Blog.Media/Randoms.Media/all_vs_all.gif'
import llm_arch from '../../Media/Blog.Media/Randoms.Media/llm_arch.jpg'
import ai_eng_map from '../../Media/Blog.Media/Randoms.Media/ai_eng_map.jpg'
import langc_vs_langg from '../../Media/Blog.Media/Randoms.Media/langc_vs_langg.jpg'
import rag_arch from '../../Media/Blog.Media/Randoms.Media/rag_arch.jpg'
import graph_ing from '../../Media/Blog.Media/Randoms.Media/graph_ing.jpg'
import ml_full_stack from '../../Media/Blog.Media/Randoms.Media/ml_full_stack.jpg'
import cheat_sheet_ml from '../../Media/Blog.Media/Randoms.Media/cheat_sheet_ml.jpg'
import mlops_complete_guide from '../../Media/Blog.Media/Randoms.Media/mlops_complete_guide.jpg'
import ml_vs_ai from '../../Media/Blog.Media/Randoms.Media/ml_vs_ai.jpg'
import rag_vs_cag from '../../Media/Blog.Media/Randoms.Media/rag_vs_cag.gif'
import twelve_statistical_tests from '../../Media/Blog.Media/Randoms.Media/twelve_statistical_tests.gif'
import twelve_papers from '../../Media/Blog.Media/Randoms.Media/12_papers.gif'
import ml_algorithms from '../../Media/Blog.Media/Randoms.Media/ml_algorithms.jpg'
import phd_prod from '../../Media/Blog.Media/Randoms.Media/phd_prod.jpg'
import genai_developer from '../../Media/Blog.Media/Randoms.Media/genai_developer.jpg'
import ai_skills from '../../Media/Blog.Media/Randoms.Media/ai_skills.jpg'
import ml_repos from '../../Media/Blog.Media/Randoms.Media/ml_repos.jpg'
import jobs_types from '../../Media/Blog.Media/Randoms.Media/jobs_types.jpg'
import processors_powering from '../../Media/Blog.Media/Randoms.Media/processors_powering.jpg'
import fam_repos from '../../Media/Blog.Media/Randoms.Media/fam_repos.jpg'
import ai_algorithms from '../../Media/Blog.Media/Randoms.Media/ai_algorithms.jpg'
import python_for_everything from '../../Media/Blog.Media/Randoms.Media/python_for_everything.jpg'
import ai_projects from '../../Media/Blog.Media/Randoms.Media/ai_projects.jpg'
import gpts from '../../Media/Blog.Media/Randoms.Media/gpts.jpg'
import ai_system from '../../Media/Blog.Media/Randoms.Media/ai_system.jpg'
import build_ai_agent from '../../Media/Blog.Media/Randoms.Media/build_ai_agent.jpg'
import ai_sys_arch from '../../Media/Blog.Media/Randoms.Media/ai_sys_arch.jpg'
import agentic_ai from '../../Media/Blog.Media/Randoms.Media/agentic_ai.jpg'
import ml_algos from '../../Media/Blog.Media/Randoms.Media/ml_algos.jpg'
import regressions from '../../Media/Blog.Media/Randoms.Media/regressions.jpg'
import python_tools from '../../Media/Blog.Media/Randoms.Media/python_tools.gif'
import tools_for_tasks from '../../Media/Blog.Media/Randoms.Media/tools_for_tasks.jpg'
import zero_telent_things from '../../Media/Blog.Media/Randoms.Media/zero_telent_things.jpg'
import git_commands from '../../Media/Blog.Media/Randoms.Media/git_commands.gif'
import business_stack from '../../Media/Blog.Media/Randoms.Media/business_stack.jpg'
import ai_roadmap from '../../Media/Blog.Media/Randoms.Media/ai_roadmap.jpg'
import ai_layers from '../../Media/Blog.Media/Randoms.Media/ai_layers.jpg'
import ai_humanizer from '../../Media/Blog.Media/Randoms.Media/ai_humanizer.jpg'

const Blog = ({ ShowMessage }) => {
    PageTitle('Blog');

    const [selectedNoteTopic, setSelectedNoteTopic] = useState('All Topics');
    
    const [selectedReportTopic, setSelectedReportTopic] = useState('All Topics');
    const [selectedReportYear, setSelectedReportYear] = useState('All Years');
    
    const [selectedPresentationTopic, setSelectedPresentationTopic] = useState('All Topics');
    const [selectedPresentationType, setSelectedPresentationType] = useState('All Types');
    const [selectedPresentationYear, setSelectedPresentationYear] = useState('All Years');

    const [selectedPosterYear, setSelectedPosterYear] = useState('All Years');
    
    const [selectedGuideTopic, setSelectedGuideTopic] = useState('All Topics');
    const [selectedGuideLevel, setSelectedGuideLevel] = useState('All Levels');
    const [selectedGuideYear, setSelectedGuideYear] = useState('All Years');

    const [selectedTaleYear, setSelectedTaleYear] = useState('All Years');
    const [selectedTalePlace, setSelectedTalePlace] = useState('All Places');
    const [selectedTaleType, setSelectedTaleType] = useState('All Types');
    
    const navigate = useNavigate();
    const handleFilterChange = (event, setter) => {
        setter(event.target.value);
    };

    // onClick: () => ShowMessage('Hatchi zin! Wait I'm still studying... 💡', 'warning'),
    // onClick: () => ShowMessage('Tsnna chwia! I'm still cooking... 🧑‍🍳', 'warning'),
    // onClick: () => ShowMessage('Wahd lerror f latex, just a minute... 🔧', 'warning'),
    // onClick: () => ShowMessage('PowerPoint mazal kay loadi, check back soon! ⏳', 'warning'),
    // onClick: () => ShowMessage('Ba9i ma3rftch kifach n3awd lik, Hold on! 😂', 'warning'),

    const notes = [
        {
            available:true,
            onClick: () => {navigate("/ADAS"); window.scrollTo({ top: 0, behavior: "smooth" });},
            image:vla,
            link:'https://drive.google.com/file/d/1T9mjRiT3EbSMJtuPAZNmKPbxYmsbqF3a/view?usp=sharing',
            title:'A Survey on Vision-Language-Action Models for Autonomous Driving',
            topic:'Autonomous Driving',
            year:'2024',
            authors:'Sicong Jiang1∗, Zilin Huang4∗, Kangan Qian2∗, Ziang Luo2, Tianze Zhu2, Yang Zhong3, Yihong Tang1, Menglin Kong1, Yunlong Wang2, Siwen Jiao3, Hao Ye3, Zihao Sheng4, Xin Zhao2, Tuopu Wen2, Zheng Fu2, Sikai Chen4, Kun Jiang2,6, Diange Yang2,6, Seongjin Choi5, Lijun Sun1',
            venue:'arXiv',
            description:'Summarizing how vision, language, and action are unified in VLAs for autonomous driving.',
            idea:'Overview covering architectures, and future directions.'
        },
        {
            available:true,
            onClick: () => {navigate("/DDPM"); window.scrollTo({ top: 0, behavior: "smooth" });},
            image:ddpm,
            link:'https://drive.google.com/file/d/1rdxewOQlqgQOd3ou9qjE-uC74PD1rKAV/view?usp=sharing',
            title:'Denoising Diffusion Probabilistic Models',
            topic:'Generative AI',
            year:'2020',
            authors:'Jonathan Ho, Ajay Jain, Pieter Abbeel',
            venue:'NeurIPS',
            description:'Explaining diffusion models intuitively:how data is slowly destroyed with noise, then learned to be reconstructed step by step to generate realistic samples.',
            idea: 'Learning to generate data by gradually denoising pure noise using a probabilistic reverse process learned from data distributions.'
        }
    ];

    const reports = [
        {
            available:true,
            onClick:() => window.open('https://drive.google.com/file/d/1rTvfjHQY0xErMYkXVPCzTfKc-LIK6xNI/view?usp=sharing', '_black'), 
            image:drivescope_rep,
            title:'Modular ADAS Design: A Single-Camera, Multi-Pipeline Approach to Efficient and Hallucination-Resistant Driving Assistance',
            topic:'Computer Vision',
            other:'',
            year:'2026',
            description:'Hallucination-resistent advanced driving assistance system.',
        },
        {
            available:true,
            onClick:() => window.open('https://drive.google.com/file/d/1VYHbbJppJZpfYNXbxCFizb_qtsHfdLvh/view?usp=sharing', '_black'), 
            image:synesthesia_rep,
            title:'Synesthesia: Cross-Modal Recommendation System for Renaissance Paintings and Classical Music in Shared Latent Space',
            topic:'Recommendation Systems',
            other:'',
            year:'2026',
            description:'Recommends music and paintings using shared latent space.',
        },
        {
            available:true,
            onClick:() => window.open('https://drive.google.com/file/d/1tWntX9251ulYY8WYk3n-cKLE3q3GeswA/view?usp=sharing', '_black'), 
            image:echomind_rep,
            title:'EchoMind: Deep Learning Model for Audio Editing via Sound Effects Integration With BERT, U-NET and DAC',
            topic:'Generative AI',
            other:'',
            year:'2026',
            description:'Adds sound effects to audios based on user prompts',
        },
        {
            available:true,
            onClick:() => window.open('https://drive.google.com/file/d/1hHuaAL8Vrvy9b5-YwqnhjgU78d-1oQCD/view?usp=sharing', '_black'), 
            image:mindscan_rep,
            title:'MindScan: Dual Deep Learning system of Brain Tumors Classification from MRI Scans',
            topic:'Computer Vision',
            other:'',
            year:'2025',
            description:'Detects and classifies brain tumors using MRI scans automatically.',
        },
        {
            available:true,
            onClick:() => window.open('https://drive.google.com/file/d/13oyeybDdbgChkfxSMUWKr2jwFOspYcFn/view?usp=sharing', '_black'), 
            image:bugscope_rep,
            title:'BugScope: Intelligent Prediction of High-Risk Files in Software Projects',
            topic:'other',
            other:'Software Engineering',
            year:'2025',
            description:'Predicts risky files in projects by analyzing code metrics.',
        },
        {
            available:true,
            onClick:() => window.open('https://drive.google.com/file/d/1W9A5rPW7IIO1oilsQL3V25ahtS2HHWTf/view?usp=sharing', '_black'), 
            image:cyberquiz_rep,
            title:'CyberQuiz: An Interactive Platform for Enhancing Cybersecurity Awareness',
            topic:'Other',
            other:'Data Collection',
            year:'2025',
            description:'Interactive platform to improve cybersecurity awareness through quizzes.',
        },
        {
            available:true,
            onClick:() => window.open('https://drive.google.com/file/d/1o-5qvhyJ6gncHhAv21tpE5ZQvvsEhFi7/view?usp=sharing', '_black'), 
            image:cortext_rep,
            title:'Cortext: A Machine Learning System For Emotion Recognition and Mood Detection from Text',
            topic:'Other',
            other:'Machine Learning',
            year:'2025',
            description:'Analyzes text to recognize user emotions and mood patterns.',
        },
        {
            available:true,
            onClick:() => window.open('https://drive.google.com/file/d/1TsXVrZmQmEfpMF_mUPjdcb787d7KsVtP/view?usp=sharing', '_black'), 
            image:moroccoinsights_rep,
            title:'Data-Driven Insights on Morocco: A Business Intelligence Approach to Population Analysis',
            topic:'Other',
            other:'Business Intelligence',
            year:'2025',
            description:'Provides population insights for Morocco using data analytics.',
        },
        {
            available:true,
            onClick:() => window.open('https://drive.google.com/file/d/1RGrQQ9Mx45HM5Cir3HsaqlC0wO6Bj88W/view?usp=sharing', '_black'), 
            image:neurodrive_rep,
            title:'NeuroDrive: An Intelligent Car Powered by Embedded Systems and Artificial Intelligence',
            topic:'Robotics',
            other:'',
            year:'2025',
            description:'Autonomous car leveraging AI and embedded systems technology.',
        },
        {
            available:true,
            onClick:() => window.open('https://drive.google.com/file/d/18RnDnL3j3Qy1phvupXgbJ8FQUFJROrbA/view?usp=sharing', '_black'), 
            image:therabot_rep,
            title:'Therabot: An Expert System for Digestive Disease Diagnosis Using Prolog',
            topic:'Other',
            other:'Expert System',
            year:'2025',
            description:'Expert system diagnosing digestive diseases using Prolog logic.',
        },
        {
            available:true,
            onClick:() => window.open('https://drive.google.com/file/d/1difmZx4Rn27IOeYc2dmJQaQEHMvz_XT2/view?usp=sharing', '_black'), 
            image:logspectrum_rep,
            title:'LogSpectrum: Design and Implementation of an Intrusion Detection and Prevention Monitoring System',
            topic:'Other',
            other:'Cyber Security',
            year:'2024',
            description:'Monitors network intrusions using intelligent detection.',
        },
        {
            available:true,
            onClick:() => window.open('https://drive.google.com/file/d/1VtVaaoEki3sajOWkKqXPxoxK0LmDBCii/view?usp=sharing', '_black'), 
            image:cabinetpro_rep,
            title:'CabinetPro: Medical Cabinet Management System',
            topic:'Other',
            other:'UML',
            year:'2023',
            description:'Manages medical cabinet inventory and tracking efficiently.',
        }
    ];

    const presentations = [
        {
            available:true,
            onClick:() => window.open('https://docs.google.com/presentation/d/12mfw7v2LrdINw9-Vn6XkuvYB5gSBdVqk/edit?usp=sharing&ouid=116921885567330793470&rtpof=true&sd=true', '_black'), 
            image:drivescope_pre,
            title:'Modular ADAS Design: ASingle-Camera, Multi-Pipeline Approach to Efficient and Hallucination-Resistant Driving Assistance',
            topic:'Computer Vision',
            type:'Project Presentation',
            year:'2026',
            description:'Multi-pipeline modular advanced driving assistance system with LLM validation for hallucination resistance',
        },
        {
            available:true,
            onClick:() => window.open('https://docs.google.com/presentation/d/12mfw7v2LrdINw9-Vn6XkuvYB5gSBdVqk/edit?usp=sharing&ouid=116921885567330793470&rtpof=true&sd=true', '_black'), 
            image:synesthesia_pre,
            title:'Synesthesia: Cross-modal Recommendation System of Paintings and Music Using a Shared Latent Space',
            topic:'Recommendation Systems',
            type:'Project Presentation',
            year:'2026',
            description:'Cross-modal system linking visual art and music via a shared emotional latent space.',
        },
        {
            available:true,
            onClick:() => window.open('https://docs.google.com/presentation/d/1143BzTT4bWdrhxpAOyp0J5B-1V0A1LIH/edit?usp=sharing&ouid=116921885567330793470&rtpof=true&sd=true', '_black'), 
            image:graphsage_pre,
            title:'GraphSAGE: Inductive Representation Learning on Large-Scale Graphs',
            topic:'Recommendation Systems',
            type:'Educational Presentation',
            other:'',
            year:'2026',
            description:'Inductive graph neural network for scalable node representation learning.',
        },
        {
            available:true,
            onClick:() => window.open('https://docs.google.com/presentation/d/1DB7e30fQABBYsCOqjpCsvDc24lMJ3MKj/edit?usp=sharing&ouid=116921885567330793470&rtpof=true&sd=true', '_black'), 
            image:wavegan_pre,
            title:'WaveGAN: Generative Adversarial Networks for Raw Audio Waveform Synthesis',
            topic:'Generative AI',
            type:'Educational Presentation',
            other:'',
            year:'2025',
            description:'Generative adversarial model for raw audio waveform synthesis.',
        },
        {
            available:true,
            onClick:() => window.open('https://docs.google.com/presentation/d/1lOna3VYeIYCIDqhpkCTPGqAf5_6p_YVe/edit?usp=sharing&ouid=116921885567330793470&rtpof=true&sd=true', '_black'), 
            image:cyberquiz_pre,
            title:'CyberQuiz: An Interactive Web Platform for Cybersecurity Awareness',
            topic:'Other',
            type:'Project Presentation',
            other:'Data Collection',
            year:'2025',
            description:'Interactive quiz-based platform for cybersecurity education and awareness.',
        },
        {
            available:true,
            onClick:() => window.open('https://docs.google.com/presentation/d/1baatOp-oFn5NLHyiIPa9NuYpiriAT_WA/edit?usp=sharing&ouid=116921885567330793470&rtpof=true&sd=true', '_black'), 
            image:genx_pre,
            title:'GenX: Diffusion Models for Image Generation',
            topic:'Generative AI',
            type:'Educational Presentation',
            other:'',
            year:'2025',
            description:'Probabilistic generative models for high-quality image synthesis.',
        },
        {
            available:true,
            onClick:() => window.open('https://docs.google.com/presentation/d/1GElDU3aTYiEBbl0Zu6RNoJbCbWALYLxU/edit?usp=sharing&ouid=116921885567330793470&rtpof=true&sd=true', '_black'), 
            image:dermalyze_pre,
            title:'Dermalyze: Deep Learning-Driven Dermoscopic Analysis for Early Skin Cancer Detection',
            topic:'Computer Vision',
            type:'Project Presentation',
            other:'',
            year:'2025',
            description:'Computer vision system for early skin cancer detection.',
        },
        {
            available:true,
            onClick:() => window.open('https://docs.google.com/presentation/d/1ok-tSFS1AeRvg-qeEYO7FGqZh-519yEv/edit?usp=sharing&ouid=116921885567330793470&rtpof=true&sd=true', '_black'), 
            image:cortext_pre,
            title:'Cortext: A Machine Learning System For Emotion Recognition and Mood Detection from Text',
            topic:'Natural Language Processing',
            type:'Project Presentation',
            other:'',
            year:'2025',
            description:'Text-based emotion recognition and mood classification system.',
        },
        {
            available:true,
            onClick:() => window.open('https://docs.google.com/presentation/d/10ZSyHoWC_Rd0MuiYRI6mbQNbXYn6O0j8/edit?usp=sharing&ouid=116921885567330793470&rtpof=true&sd=true', '_black'), 
            image:clinicalner_pre,
            title:'ClinicalNER: Enhancing Medical Document Analysis with Named Entity Recognition',
            topic:'Other',
            type:'Project Presentation',
            other:'Named Entity Recognition',
            year:'2025',
            description:'Named entity recognition system for clinical text analysis.',
        },
        {
            available:true,
            onClick:() => window.open('https://docs.google.com/presentation/d/1p5hwlXXI2S1J7zB2qj31dfq93hD6VSeO/edit?usp=sharing&ouid=116921885567330793470&rtpof=true&sd=true', '_black'), 
            image:db4o_pre,
            title:'db4o: A Complete Guide to Object-Oriented Databases',
            topic:'Other',
            type:'Educational Presentation',
            other:'Databases',
            year:'2024',
            description:'Overview of object-oriented database concepts and usage.',
        },
    ];

    const posters = [
        // {available:true, image:navigation_system, year:'2026'},
        {available:true, image:pulsex_pos, year:'2025'},
        {available:true, image:neurodrive_pos, year:'2024'},
    ];

    const guides = [
        // {
        //     // available:true,
        //     onClick:() => ShowMessage('Tsnna chwia! I\'m still cooking... 🧑‍🍳', 'warning'),
        //     image:neural_network,
        //     title:'Bchwia 3lik Till You Make Your First Neural Network From Scratch',
        //     topic:'Deep Learning',
        //     level:'Advanced',
        //     year:'2026',
        //     duration:'60-90 min',
        //     prerequisites:'Linear algebra basics, Python, gradient descent',
        //     tools:['Python', 'NumPy'],
        //     outcome:'You will understand and implement a simple neural network from scratch without using ML frameworks.',
        //     description:'Dive into the fundamentals of neural networks and build one from scratch using only code—no frameworks, just pure logic and math.'
        // },
        {
            available:true,
            onClick:() => {navigate("/RaspberryPi"); window.scrollTo({ top: 0, behavior: "smooth" });},
            image:raspberry,
            title:'D9a D9a Workflow of How To Set Up Raspberry Pi For Your Robotics Projects',
            topic:'Embedded Systems',
            level:'Intermediate',
            year:'2026',
            duration:'45-60 min',
            prerequisites:'Basic Linux knowledge',
            tools:['Raspberry Pi', 'MicroSD Card', 'Power Supply', 'Raspberry Pi OS'],
            outcome:'You will have a fully configured Raspberry Pi ready for robotics or automation projects.',
            description:'Master the steps to set up Raspberry Pi, from OS installation to GPIO usage, ideal for smart robotics and intelligent automation projects.'
        },
        {
            available:true,
            onClick:() => {navigate("/Arduino"); window.scrollTo({ top: 0, behavior: "smooth" });},
            image:arduino,
            title:'Sahla Mahla of How To Prepare Arduino For Your Embedded Systems Projects',
            topic:'Embedded Systems',
            level:'Beginner',
            year:'2026',
            duration:'30-45 min',
            prerequisites:'Basic C/C++',
            tools:['Arduino Uno', 'USB Cable', 'Arduino IDE'],
            outcome:'You will upload your first sketch and understand the Arduino workflow.',
            description:'Quickly learn how to connect, code, and upload programs to Arduino for smart embedded systems and simple automation tasks.'
        },
        {
            available:true,
            onClick:() => {navigate("/Git"); window.scrollTo({ top: 0, behavior: "smooth" });},
            image:git,
            title:'Khochaybat Guide of How To Use Git To Control And Track Your Projects',
            topic:'Dev Tools',
            level:'Beginner',
            year:'2026',
            duration:'20-30 min',
            prerequisites:'Basic command-line usage',
            tools:['Git', 'GitHub'],
            outcome:'You will be able to initialize repositories, commit changes, and track project history using Git.',
            description:'Understand Git basics, from branching to version tracking, and improve your project collaboration with clean and organized workflows.'
        },
    ];

    const tales = [
        // how i started fitness
        // how i started chess and played its tournament
        // tale about how i went to germany
        // tale about 1317 hackathon
        // tale about asfi hackathon
        // tale about fssm hackathon
        {
            // available:true,
            onClick:() => ShowMessage('Ba9i ma3rftch kifach n3awd lik, Hold on! 😂', 'warning'),
            image:embedded_system,
            title:'A Tale of Embedded Awakening',
            type:'Education',
            place:'FSSM',
            date:'2024',
            context:'First serious exposure to microcontrollers during university labs.',
            challenge:'Understanding GPIO behavior and timing issues.',
            lessonLearned:'Hardware forces you to respect reality, not assumptions.',
            mood:'Reflective',
            description:'How I stumbled into the world of microcontrollers, learned to tame GPIO pins, and found unexpected joy in making LEDs dance and sensors talk.'
        }
    ];

    const randoms = [
        // {available:true, image:, link:''},
        {available:true, image:read_paper, link:'https://lnkd.in/p/ePT3SAUh'},
        {available:true, image:phd_thesis, link:'https://lnkd.in/p/et49d4uE'},
        {available:true, image:mach_alg_exp, link:'https://lnkd.in/p/ecqAbi_i'},
        {available:true, image:should_use, link:'https://lnkd.in/p/eK54U-B4'},
        {available:true, image:tpu_gpu_npu_lpu, link:'https://www.linkedin.com/posts/kavi-priyan-26x12_artificialintelligence-ai-machinelearning-share-7482677469196689408-jRls/'},
        {available:true, image:ai_terms, link:'https://www.linkedin.com/posts/jamal-awan_artificialintelligence-machinelearning-generativeai-share-7495039781396176896-9t3w/'},
        {available:true, image:master_tree, link:'https://www.linkedin.com/posts/rushika-rai-a58345254_from-mathematics-to-machine-learning-systems-share-7494333109342216192-Fy3w/'},
        {available:true, image:prob_dist, link:'https://www.linkedin.com/feed/update/urn:li:groupPost:6744146-7495004285894684674/?rcm=ACoAAE3y4CwBYA4xIpTO9I0M8ns40JVs08bfoYk'},
        {available:true, image:yolo_family, link:'https://www.linkedin.com/posts/mohamed-ghareeb-85178a377_ai-computervision-yolo-share-7492767244439990272-afoA/'},
        {available:true, image:finetunning, link:'https://www.linkedin.com/posts/arynnraj_what-if-i-told-you-you-dont-need-to-train-share-7493352370802950145-6k76/'},
        {available:true, image:beginning, link:'https://www.linkedin.com/posts/drmuhammadmohsin_artificialintelligence-machinelearning-deeplearning-share-7492735366077284352-dBLE/'},
        {available:true, image:ai_videos, link:'https://www.linkedin.com/posts/ved-prakash-meena_10-aiml-learning-playlists-on-youtube-share-7490973250512945153-kbOq/'},
        {available:true, image:claude_md, link:'https://www.linkedin.com/posts/leadgenmanthan_%F0%9D%97%A0%F0%9D%97%BC%F0%9D%98%80%F0%9D%98%81-%F0%9D%97%B1%F0%9D%97%B2%F0%9D%98%83%F0%9D%97%B2%F0%9D%97%B9%F0%9D%97%BC%F0%9D%97%BD%F0%9D%97%B2%F0%9D%97%BF%F0%9D%98%80-%F0%9D%98%84%F0%9D%97%BF%F0%9D%97%B6%F0%9D%98%81%F0%9D%97%B2-share-7491378928671121408-ZdJZ/'},
        {available:true, image:which_tool, link:'https://www.linkedin.com/posts/dr-faheem-ullah_phd-research-tools-share-7486702967354560512-OERs/'},
        {available:true, image:all_vs_all, link:'https://www.linkedin.com/posts/ai-future-innovation-share-7490388499905335296-7ONb/'},
        {available:true, image:llm_arch, link:'https://www.linkedin.com/posts/kummara-siva-rudra-019509254_llm-architecture-explained-simple-beginner-share-7487557449059721216-2xjp/'},
        {available:true, image:ai_eng_map, link:'https://www.linkedin.com/posts/rjritikjain_ai-aiengineer-machinelearning-share-7487707090426224640-OwMJ/'},
        {available:true, image:langc_vs_langg, link:'https://www.linkedin.com/posts/dalihabli_ai-artificialintelligence-langchain-share-7485125467457601536-87eb/'},
        {available:true, image:rag_arch, link:'https://www.linkedin.com/posts/arynnraj_8-rag-architectures-for-ai-engineers-explained-share-7487549140512665600-i9Iv/'},
        {available:true, image:graph_ing, link:'https://www.linkedin.com/posts/femke-plantinga_why-is-graph-engineering-suddenly-everywhere-share-7487775962856861696-TI2O/'},
        {available:true, image:ml_full_stack, link:'https://www.linkedin.com/posts/aditya-mishra-70943323b_artificialintelligence-machinelearning-deeplearning-share-7487347043821301760-H94S/'},
        {available:true, image:cheat_sheet_ml, link:'https://www.linkedin.com/posts/iamarifalam_%F0%9D%97%A0%F0%9D%97%AE%F0%9D%97%B0%F0%9D%97%B5%F0%9D%97%B6%F0%9D%97%BB%F0%9D%97%B2-%F0%9D%97%9F%F0%9D%97%B2%F0%9D%97%AE%F0%9D%97%BF%F0%9D%97%BB%F0%9D%97%B6%F0%9D%97%BB%F0%9D%97%B4-%F0%9D%97%94%F0%9D%97%B9%F0%9D%97%B4%F0%9D%97%BC%F0%9D%97%BF%F0%9D%97%B6%F0%9D%98%81%F0%9D%97%B5%F0%9D%97%BA-share-7486628076949471232-c1j0/'},
        {available:true, image:mlops_complete_guide, link:'https://www.linkedin.com/posts/rahul-y-642ba13a3_mlops-machinelearning-aiengineering-share-7486951902211903488-6Hq5/'},        
        {available:true, image:ml_vs_ai, link:'https://www.linkedin.com/posts/muhammad-ghufran-4929b82b5_artificialintelligence-aiengineer-machinelearning-share-7486391152578056192-ZIM0/'},
        {available:true, image:rag_vs_cag, link:'https://www.linkedin.com/posts/ahalya-dasari_artificialintelligence-rag-cag-share-7485896620736401408-YEkS/'},
        {available:true, image:twelve_statistical_tests, link:'https://www.linkedin.com/posts/saibysani18_every-data-professional-forgets-which-statistical-share-7486419309683171328-fryL/'},
        {available:true, image:twelve_papers, link:'https://www.linkedin.com/posts/fineanmol_systemdesign-coding-interviewtips-share-7459358432379187200-_CIT/'},
        {available:true, image:ml_algorithms, link:'https://www.linkedin.com/posts/i-mapped-16-ml-algorithms-across-8-decision-share-7483372354803376129-QOzT/'},
        {available:true, image:phd_prod, link:'https://www.linkedin.com/feed/update/urn:li:activity:7484274232366030848/?rcm=ACoAAE3y4CwBYA4xIpTO9I0M8ns40JVs08bfoYk'},
        {available:true, image:genai_developer, link:'https://www.linkedin.com/posts/syedabdul-aman-genai-developer_machinelearning-mlops-artificialintelligence-share-7483401110536314881-kS3B/'},
        {available:true, image:ai_skills, link:'https://www.linkedin.com/posts/abdullah-mehboob-13b9712b4_datascience-machinelearning-python-share-7482540641432899584-44ds/'},
        {available:true, image:ml_repos, link:'https://www.linkedin.com/posts/arynnraj_16-github-repos-that-teach-more-than-a-1000-share-7481933182079082499-pT2q/'},
        {available:true, image:jobs_types, link:'https://www.linkedin.com/feed/update/urn:li:activity:7452635704947535873/?rcm=ACoAAE3y4CwBYA4xIpTO9I0M8ns40JVs08bfoYk'},
        {available:true, image:processors_powering, link:'https://www.linkedin.com/posts/essaid-el-bachari-288649241_share-7447012227041107968-C41V/'},
        {available:true, image:fam_repos, link:'https://www.linkedin.com/feed/update/urn:li:activity:7442879034000072704/?rcm=ACoAAE3y4CwBYA4xIpTO9I0M8ns40JVs08bfoYk'},
        {available:true, image:ai_algorithms, link:'https://www.linkedin.com/feed/update/urn:li:activity:7435255110089396224/?rcm=ACoAAE3y4CwBYA4xIpTO9I0M8ns40JVs08bfoYk'},
        {available:true, image:python_for_everything, link:'https://www.linkedin.com/posts/elyes-lounissi_python-is-everywhere-from-data-manipulation-share-7427120401387925504-GBce'},
        {available:true, image:ai_projects, link:'https://www.linkedin.com/posts/siddheswar-lachyane_your-resume-isnt-failing-your-projects-share-7426936355714162688-Pkkn'},
        {available:true, image:gpts, link:'https://www.linkedin.com/posts/small-businesses-dont-need-100-ai-tools-share-7426207961162772480-eO0I'},
        {available:true, image:ai_system, link:'https://www.linkedin.com/posts/subbarajuk_artificialintelligence-generativeai-llm-share-7425915637786464256-qfSi'},
        {available:true, image:build_ai_agent, link:'https://www.linkedin.com/posts/essaid-el-bachari-288649241_share-7478386119584391168-5mx4/'},
        {available:true, image:ai_sys_arch, link:'https://www.linkedin.com/posts/dalihabli_aiarchitecture-llmsystems-agenticai-share-7423343020911132672-ELd3'},
        {available:true, image:agentic_ai, link:'https://www.linkedin.com/posts/pikumaity_agenticai-artificialintelligence-aidevelopment-share-7423327719964229632--cQJ'},
        {available:true, image:ml_algos, link:'https://www.linkedin.com/feed/update/urn:li:groupPost:3063585-7423206106472062976?rcm=ACoAAE3y4CwBYA4xIpTO9I0M8ns40JVs08bfoYk'},
        {available:true, image:regressions, link:'https://www.linkedin.com/feed/update/urn:li:groupPost:6744146-7424339293759967232?rcm=ACoAAE3y4CwBYA4xIpTO9I0M8ns40JVs08bfoYk'},
        {available:true, image:python_tools, link:'https://www.linkedin.com/posts/reshmawithai_stop-saving-random-ai-tools-start-understanding-share-7422500421090578433-zWsl'},
        {available:true, image:tools_for_tasks, link:'https://www.linkedin.com/posts/saifalramahi_chatgpt-cant-do-it-all-heres-when-to-use-activity-7420800467821088768--Nqk'},
        {available:true, image:zero_telent_things, link:'https://www.linkedin.com/posts/manojsaraswatic_discipline-successmindset-leadershipdevelopment-share-7421935398991454208-QC3b'},
        {available:true, image:git_commands, link:'https://www.linkedin.com/posts/a-hemeda_%D9%84%D9%88-%D8%A8%D8%AA%D8%B3%D8%AA%D8%AE%D8%AF%D9%85-git-%D9%88%D8%A8%D8%AA%D9%86%D8%B3%D9%89-%D8%A7%D9%84%D8%A3%D9%88%D8%A7%D9%85%D8%B1-%D8%A8%D8%B3%D8%B1%D8%B9%D9%87-%D8%A7%D9%84%D8%B5%D9%88%D8%B1%D9%87-share-7421874397340409857-LUUD'},
        {available:true, image:business_stack, link:'https://www.linkedin.com/posts/charlie-hills_i-run-multi-6-figure-creator-business-these-activity-7417883329833623552-1z73'},
        {available:true, image:ai_roadmap, link:'https://www.linkedin.com/posts/essaid-el-bachari-288649241_share-7413529103435321345-fNPP'},
        {available:true, image:ai_layers, link:'https://www.linkedin.com/posts/essaid-el-bachari-288649241_activity-7414926294444101632-hlyV'},
        {available:true, image:ai_humanizer, link:'https://www.linkedin.com/posts/charlie-hills_this-is-the-best-ai-humaniser-prompt-ive-activity-7416071387557359616-4nnD'}
    ];

    const filterNotes = (note) => {
        const noteTopicMatch = selectedNoteTopic === 'All Topics' || note.topic === selectedNoteTopic;
        return noteTopicMatch;
    }
    
    const filterReports = (report) => {
        const reportTopicMatch = selectedReportTopic === 'All Topics' || report.topic === selectedReportTopic;
        const reportYearMatch = selectedReportYear === 'All Years' || report.year === selectedReportYear;
        return reportTopicMatch && reportYearMatch;
    }
    
    const filterPresentations = (presentation) => {
        const presentationTopicMatch = selectedPresentationTopic === 'All Topics' || presentation.topic === selectedPresentationTopic;
        const presentationTypeMatch = selectedPresentationType === 'All Types' || presentation.type === selectedPresentationType;
        const presentationYearMatch = selectedPresentationYear === 'All Years' || presentation.year === selectedPresentationYear;
        return presentationTopicMatch && presentationTypeMatch && presentationYearMatch;
    }

    const filterPosters = (poster) => {
        const posterYearMatch = selectedPosterYear === 'All Years' || poster.year === selectedPosterYear;
        return posterYearMatch;
    }
    
    const filterGuides = (guide) => {
        const guideTopicMatch = selectedGuideTopic === 'All Topics' || guide.topic === selectedGuideTopic;
        const guideLevelMatch = selectedGuideLevel === 'All Levels' || guide.level === selectedGuideLevel;
        const guideYearMatch = selectedGuideYear === 'All Years' || guide.year === selectedGuideYear;
        return guideTopicMatch && guideLevelMatch && guideYearMatch;
    }
    
    const filterTales = (tale) => {
        const taleYearMatch = selectedTaleYear === 'All Years' || tale.date === selectedTaleYear;
        const talePlaceMatch = selectedTalePlace === 'All Places' || tale.place === selectedTalePlace;
        const taleTypeMatch = selectedTaleType === 'All Types' || tale.type === selectedTaleType;

        return taleYearMatch && talePlaceMatch && taleTypeMatch;
    }

    return (
        <>
            <SEO 
                title="Blog"
                description="Technical blog covering AI, machine learning, deep learning, web development, and software engineering. Tutorials, insights, project breakdowns, and lessons learned from building intelligent systems."
                url="https://yassinebazgour.vercel.app/Blog"
                keywords="AI blog, machine learning tutorials, deep learning articles, web development blog, Python tutorials, React tutorials, tech insights, programming blog, software engineering blog"
            />
            <section className='blog-section'>
                <div className='notes-container'>
                    <span className='blog-title'>Paper Notes</span>
                    <span className='blog-description'>Simplified explanations of scientific research papers<br/> I've read, and what I actually understood.<br/> Written from scratch. If you spot any issues, please contact me.</span>
                    <span className='blog-count-span'>
                        Explained Papers:
                        <span className='notes-count-number'> {notes.filter(n => n.available).length}</span>
                    </span>

                    <div className='blog-selects-container'>
                        <select className='blog-select' onChange={(e) => handleFilterChange(e, setSelectedNoteTopic)}>
                            <option>All Topics</option>
                            <option>Generative AI</option>
                            <option>Autonomous Driving</option>
                        </select>
                    </div>

                    <div className='blogs-container'>
                        {notes.filter(filterNotes).length === 0 ? (
                            <span className='no-available-blog'>No paper explanations available for the selected filters. 😔</span>
                        ) : (
                            notes.filter(filterNotes).map((note, index) => (
                                <Note
                                key={index}
                                    {...note}
                                />
                            ))
                        )}
                    </div>
                </div>
                <Separator/>
                <div className='reports-container'>
                    <span className='blog-title'>Reports</span>
                    <span className='blog-description'>
                        Structured technical reports documenting my projects,<br/> design decisions, experiments, and results.
                    </span>
                    <span className='blog-count-span'>
                        Documented Reports:
                        <span className='reports-count-number'> {reports.filter(r => r.available).length}</span>
                    </span>
                    <div className='blog-selects-container'>
                        <select className='blog-select' onChange={(e) => handleFilterChange(e, setSelectedReportTopic)}>
                            <option>All Topics</option>
                            <option>Generative AI</option>
                            <option>Computer Vision</option>
                            <option>Recommendation Systems</option>
                            <option>Robotics</option>
                            <option>Other</option>
                        </select>
                        <select className='blog-select' onChange={(e) => handleFilterChange(e, setSelectedReportYear)}>
                            <option>All Years</option>
                            <option>2026</option>
                            <option>2025</option>
                            <option>2024</option>
                            <option>2023</option>
                        </select>
                    </div>
                    <div className='blogs-container'>
                        {reports.filter(filterReports).length === 0 ? (
                            <span className='no-available-blog'>No reports available for the selected filters. 😔</span>
                        ) : (
                            reports.filter(filterReports).map((report, index) => (
                                <Report key={index} {...report} />
                            ))
                        )}
                    </div>
                </div>
                <Separator/>
                <div className='presentations-container'>
                    <span className='blog-title'>Presentations</span>
                    <span className='blog-description'>
                        Slide-based presentations covering project walkthroughs<br/> and academic concepts explained visually and concisely.
                    </span>
                    <span className='blog-count-span'>
                        Delivered Presentations:
                        <span className='presentations-count-number'> {presentations.filter(p => p.available).length}</span>
                    </span>
                    <div className='blog-selects-container'>
                        <select className='blog-select' onChange={(e) => handleFilterChange(e, setSelectedPresentationTopic)}>
                            <option>All Topics</option>
                            <option>Generative AI</option>
                            <option>Computer Vision</option>
                            <option>Natural Language Processing</option>
                            <option>Recommendation Systems</option>
                            <option>Other</option>
                        </select>
                        <select className='blog-select' onChange={(e) => handleFilterChange(e, setSelectedPresentationType)}>
                            <option>All Types</option>
                            <option>Internship Presentation</option>
                            <option>Project Presentation</option>
                            <option>Educational Presentation</option>
                        </select>
                        <select className='blog-select' onChange={(e) => handleFilterChange(e, setSelectedPresentationYear)}>
                            <option>All Years</option>
                            <option>2026</option>
                            <option>2025</option>
                            <option>2024</option>
                        </select>
                    </div>
                    <div className='blogs-container'>
                        {presentations.filter(filterPresentations).length === 0 ? (
                            <span className='no-available-blog'>No presentations available for the selected filters. 😔</span>
                        ) : (
                            presentations.filter(filterPresentations).map((presentation, index) => (
                                <Presentation key={index} {...presentation} />
                            ))
                        )}
                    </div>
                </div>
                <Separator/>
                <div className='posters-container'>
                    <span className='blog-title'>Posters</span>
                    <span className='blog-description'>
                        Visual summaries of projects and research,<br/>
                        designed to communicate complex ideas at a glance.<br/> 
                    </span>
                    <span className='blog-count-span'>
                        Designed Posters:
                        <span className='posters-count-number'> {posters.filter(p => p.available).length}</span>
                    </span>
                    <div className='blog-selects-container'>
                        <select className='blog-select' onChange={(e) => handleFilterChange(e, setSelectedPosterYear)}>
                            <option>All Years</option>
                            <option>2026</option>
                            <option>2025</option>
                            <option>2024</option>
                        </select>
                    </div>
                    <div className='blogs-container posters-images-container'>
                        {posters.filter(filterPosters).length === 0 ? (
                            <span className='no-available-blog'>No posters available for the selected year. 😔</span>
                        ) : (
                            posters.filter(filterPosters).map((poster, index) => (
                                <img
                                    className='poster-image' 
                                    key={index} 
                                    src={poster.image} 
                                    alt={`Poster ${index}`}    
                                />
                            ))
                        )}
                    </div>
                </div>
                <Separator/>
                <div className='guides-container'>
                    <span className='blog-title'>Guides</span>
                    <span className='blog-description'>Short, practical tutorials and insights to help you<br/> navigate hardware, AI, and software projects.<br/> Written from scratch. If you spot any issues, please contact me.</span>
                    <span className='blog-count-span'>
                        Constructed Guides:
                        <span className='guides-count-number'> {guides.filter(g => g.available).length}</span>
                    </span>
                    <div className='blog-selects-container'>
                        <select className='blog-select' onChange={(e) => handleFilterChange(e, setSelectedGuideTopic)}>
                            <option>All Topics</option>
                            <option>Dev Tools</option>
                            <option>Machine Learning</option>
                            <option>Embedded Systems</option>
                            <option>Browser Extension</option>
                            <option>UML Modeling</option>
                        </select>
                        <select className='blog-select' onChange={(e) => handleFilterChange(e, setSelectedGuideLevel)}>
                            <option>All Levels</option>
                            <option>Beginner</option>
                            <option>Intermediate</option>
                            <option>Advanced</option>
                        </select>
                        <select className='blog-select' onChange={(e) => handleFilterChange(e, setSelectedGuideYear)}>
                            <option>All Years</option>
                            <option>2026</option>
                        </select>
                    </div>
                    <div className='blogs-container'>
                        {guides.filter(filterGuides).length === 0 ? (
                            <span className='no-available-blog'>No Guides available for the selected topic. 😔</span>
                        ) : (
                            guides.filter(filterGuides).map((guide, index) => (
                                <Guide 
                                key={index}
                                {...guide}
                                />
                            ))
                        )}
                    </div>
                </div>
                <Separator/>
                <div className='tales-container'>
                    <span className='blog-title'>Tales</span>
                    <span className='blog-description'>Stories behind my projects, the successes, failures, and<br/>lessons learned along the way.</span>
                    <span className='blog-count-span'>
                        Narrated Tales:
                        <span className='tales-count-number'> {tales.filter(t => t.available).length}</span>
                    </span>
                    <div className='blog-selects-container'>
                        <select className='blog-select' onChange={(e) => handleFilterChange(e, setSelectedTalePlace)}>
                            <option>All Places</option>
                            <option>FSSM</option>
                            <option>Hackathon</option>
                            <option>Home Lab</option>
                        </select>
                        <select className='blog-select' onChange={(e) => handleFilterChange(e, setSelectedTaleType)}>
                            <option>All Types</option>
                            <option>Education</option>
                            <option>Hackathon</option>
                            <option>Sport</option>
                        </select>
                        <select className='blog-select' onChange={(e) => handleFilterChange(e, setSelectedTaleYear)}>
                            <option>All Years</option>
                            <option>2025</option>
                            <option>2024</option>
                        </select>
                    </div>
                    <div className='blogs-container'>
                        {tales.filter(filterTales).length === 0 ? (
                            <span className='no-available-blog'>No tales available for the selected filters. 😔</span>
                        ) : (
                            tales.filter(filterTales).map((tale, index) => (
                                <Tale 
                                    key={index}
                                    {...tale}
                                />
                            ))
                        )}
                    </div>
                </div>
                <Separator/>
                <div className='randoms-container'>
                    <span className='blog-title'>Randoms</span>
                    <span className='blog-description'>
                        Detours from the main mission: visuals, concepts, and random AI stuff living<br/> 
                        rent-free in my head. Things that made me stop and say “wait… that’s cool”.<br/> 
                        <span className='click-random'>Click</span> on 
                        the image to see the original source where it was first discovered.</span>
                    <span className='blog-count-span'>
                        Snapped Randoms:
                        <span className='randoms-count-number'> {randoms.filter(r => r.available).length}</span>
                    </span>
                    <div className='blogs-container randoms-images-container'>
                        {randoms
                            .filter(random => random.available)
                            .map((random, index) => (
                                <img 
                                    onClick={() => window.open(random.link, 'blank')} 
                                    className='random-image' 
                                    key={index} 
                                    src={random.image} 
                                    alt={`Random ${index}`} 
                                />
                            ))
                        }
                    </div>
                </div>
            </section>
        </>
    )
}

export default Blog